import React from 'react';

interface ValidationWineInfoTableProps {
  retailerDescription: string;
  vintage: string;
  fromValidation?: boolean;
}

const ValidationWineInfoTable: React.FC<ValidationWineInfoTableProps> = ({ 
  retailerDescription, 
  vintage,
  fromValidation
}) => {
  return (
    <div className="mb-5 border rounded-lg">
      <div className="grid grid-cols-1">
        <div className="border-b">
          <div className="grid grid-cols-12 border-b">
            <div className="col-span-2 font-medium text-sm py-2 px-2 bg-gray-50 border-r">Retailer Description</div>
            <div className="col-span-10 py-2 px-2">{retailerDescription}</div>
          </div>
          <div className="grid grid-cols-12">
            <div className="col-span-2 font-medium text-sm py-2 px-2 bg-gray-50 border-r">Vintage</div>
            <div className="col-span-10 py-2 px-2">{vintage}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValidationWineInfoTable;
